import React from "react";
import { PsModal } from "src/components/General/Modal";
import { CommunityFaq } from "./CommunityFaq";
import { GeneralFaq } from "./GeneralFaq";
import { ProviderFaq } from "./ProviderFaq";

export interface FaqProps {
  groups: string[];
}

export const Faq: React.FunctionComponent<FaqProps> = (props: FaqProps) => {
  const [faqModal, setShowFaqModal] = React.useState(false);
  return (
    <div className="mt-4">
      <div id="tour-faq">
        <i className="fw400">Questions?</i> 🤔 Try our{" "}
        <a className="cursor-pointer" onClick={(): void => setShowFaqModal(true)}>
          FAQ
        </a>
      </div>
      <PsModal title="FAQ" visible={faqModal} toggleCb={(): void => setShowFaqModal(false)}>
        {props.groups.includes("provider") && <ProviderFaq />}
        {props.groups.includes("community") && <CommunityFaq />}
        <GeneralFaq
          contextSpecific={
            props.groups.includes("provider") === true
              ? [
                {
                  title: "What is Slack?",
                  content: (
                      <div>
                        Slack is a platform where you can read and post content to channels on specific topics. For example, we have a
                        channel for referrals, professional training and events, announcements, and more. You can direct message individuals
                        in Slack as well.{" "}
                        <a
                          href="https://join.slack.com/t/psychedelic-support/shared_invite/zt-dbxxv8qp-UC1wwhclN~1ZyFXOr4Xftg"
                          target="_blank" rel="noreferrer"
                        >
                          Click this link
                        </a>{" "}
                        to join our Slack conversation.
                      </div>
                  ),
                },
              ]
              : null
          }
        />
      </PsModal>
    </div>
  );
};
